var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback } from 'react';
import useUnmount from './useUnmount';
function useDebounce(func, timeout, deps) {
    var _this = this;
    if (deps === void 0) { deps = []; }
    var id = null;
    var debouncedFunction = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(id);
        id = setTimeout(function () { return func.apply(_this, args); }, timeout);
    }, __spreadArray(__spreadArray([], deps, true), [func], false));
    useUnmount(function () { return clearTimeout(id); });
    return debouncedFunction;
}
export default useDebounce;
